import React, { useEffect, useState } from "react";
import api from "../../../configs/api";
import CustomInput from "../../ui/custom-inputs/CustomInput";
import GeneralSelect from "../../ui/custom-inputs/select-inputs/GeneralSelect";
import { ACCEPT_IMAGES_TYPES_OBJECT, ACCEPT_PDF_TYPES_OBJECT, childConditionOptions, MAX_SIZE_IMAGE } from "../../../utils/constants";
import FileDropzone from "../../ui/FileDropzone";
import ShowingFile from "../../ui/ShowingFile";

export default function EditModal({
  handleModal,
  setIsEdit,
  isEdit,
  setStatus,
  userInfoForUpdate,
}) {
  const [user, setUser] = useState({});

  const [childReport, setChildReport] = useState([]);

  useEffect(() => {
    setUser(userInfoForUpdate);
  }, [userInfoForUpdate]);

  async function UpdateUser(e) {
    e.preventDefault();

    try {
      await api.put(`admin/update_user/${user._id}`, { ...user, childReport: childReport.map(file => file.fileUrl) });

      setStatus({
        show: true,
        icon: "success",
        title: "User added successfully",
        description: "",
        showConfirmButton: false,
        timer: 5000,
      });
      setIsEdit(false);
      setChildReport([]);
    } catch (error) {
      setStatus({
        show: true,
        icon: "error",
        title: "something went wrong, please try again later",
        description: "",
        showConfirmButton: false,
        timer: 5000,
      });

      console.error("Error add user:", error);
    }
  }

  function handleChange(e) {
    setUser({ ...user, [e.target.name]: e.target.value });
  }

  return (
    <>
      {/* Update User Modal */}
      <div
        className={`fixed inset-0 z-50 ${isEdit ? "flex" : "hidden "
          } items-center justify-center p-10 bg-gray-800 bg-opacity-50 overflow-x-hidden overflow-y-auto`}
      >
        <div className='relative w-full h-[80%] max-w-2xl px-4 overflow-y-scroll '>
          {/* Modal content */}
          <div className='relative bg-white rounded-lg shadow dark:bg-gray-800'>
            {/* Modal header */}
            <div className='flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700'>
              <h3 className='text-xl font-semibold dark:text-white'>
                Edit User
              </h3>
              <button
                onClick={() => handleModal(setIsEdit, false)}
                type='button'
                className='text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white'
                data-modal-toggle='add-user-modal'
              >
                <svg
                  className='w-5 h-5'
                  fill='currentColor'
                  viewBox='0 0 20 20'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fillRule='evenodd'
                    d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                    clipRule='evenodd'
                  />
                </svg>
              </button>
            </div>
            {/* Modal body */}
            <div className='p-6 space-y-6'>
              <form onSubmit={(e) => UpdateUser(e)}>
                <div className='grid grid-cols-6 gap-6'>
                  <div className='col-span-6 sm:col-span-3'>
                    <label
                      htmlFor='parentName'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      Parent Name
                    </label>
                    <CustomInput
                      onChange={handleChange}
                      value={user?.parentName}
                      type='text'
                      name='parentName'
                      id='parentName'
                      placeholder='Parent Name'
                      required
                    />
                  </div>
                  <div className='col-span-6 sm:col-span-3'>
                    <label
                      htmlFor='phone'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      Phone Number
                    </label>
                    <CustomInput
                      onChange={handleChange}
                      value={user?.phone}
                      type='number'
                      name='phone'
                      id='phone'
                      placeholder='Phone Number'
                      required
                    />
                  </div>
                  <div className='col-span-6 sm:col-span-3'>
                    <label
                      htmlFor='childCondition'
                      className='block mb-2 text-sm font-medium  text-start '
                    >
                      Child Condition
                    </label>
                    <GeneralSelect
                      options={childConditionOptions}
                      handleChange={(val) => {
                        setUser({ ...user, childCondition: val?.value })
                      }}
                      defaultValue={user?.childCondition}
                      name={"childCondition"}
                    />
                    {user.childCondition === "other" && (
                      <CustomInput
                        type='text'
                        className='bg-gray-50 border border-gray-300 text-gray-900 h-10 text-sm rounded-lg block w-full p-2.5 '
                        name='customCondition'
                        value={user?.childCondition || ""}
                        onChange={handleChange}
                        placeholder='أدخل الحالة الأخرى...'
                        dir='rtl'
                      />
                    )}
                  </div>
                  <div className='col-span-6 sm:col-span-3'>
                    <label
                      htmlFor='email'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      Email
                    </label>
                    <CustomInput
                      onChange={handleChange}
                      value={user?.email}
                      type='email'
                      name='email'
                      id='email'
                      placeholder='Email'
                      required
                    />
                  </div>
                  <div className='col-span-6 sm:col-span-3'>
                    <label
                      htmlFor='childName'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      Child Name
                    </label>
                    <CustomInput
                      onChange={handleChange}
                      value={user?.childName}
                      type='text'
                      name='childName'
                      id='childName'
                      placeholder='Child Name'
                      required
                    />
                  </div>
                  <div className='col-span-6 sm:col-span-3'>
                    <label
                      htmlFor='birthday'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      Birthday
                    </label>
                    <CustomInput
                      onChange={handleChange}
                      value={user?.birthday}
                      type='date'
                      name='birthday'
                      id='birthday'
                      placeholder='Birthday'
                      required
                    />
                  </div>
                </div>

                <br />

                <div className='flex text-sm'>
                  <label
                    htmlFor='childReport'
                    className='block mb-2 font-medium text-black '
                  >
                    Child Reports
                  </label>
                </div>
                <FileDropzone
                  setState={setChildReport}
                  value={childReport}
                  filesAccept={{ ...ACCEPT_IMAGES_TYPES_OBJECT, ...ACCEPT_PDF_TYPES_OBJECT }}
                  name="childReport"
                  maxSize={MAX_SIZE_IMAGE}
                >
                </FileDropzone>
                <ShowingFile values={childReport} setValues={setChildReport} />
                <div className='flex items-center pt-5 mt-5 justify-center border-t border-gray-200 rounded-b dark:border-gray-700 '>
                  <button
                    className='text-white bg-primary hover:bg-buttonFocus focus:ring-4 focus:ring-buttonFocus font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-buttonHover dark:hover:bg-primary dark:focus:ring-buttonFocus'
                    type='submit'
                  >
                    Add user
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
